module.exports = require("core-js/modules/esnext.set.is-disjoint-from.js");